import { AppDispatch, RootState } from './../../app/store';
import { createSlice } from '@reduxjs/toolkit'
import { dialogState, globalDialogStatus } from './globalDialogTypes';
import { getWithAuth } from '../../utils/api';

const initialState: dialogState = {
    status: globalDialogStatus.initialLoading,
}

const globalDialogSlice = createSlice({
    name: "dialog",
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.status = action.payload;
        },

    }
});

export const {
    setStatus
} = globalDialogSlice.actions

export const selectStatus = (state: RootState): globalDialogStatus => state.dialog.status;

export const getHealth = (numberOfInstances: number) => (dispatch: AppDispatch): void => {
    const calls = new Array<Promise<number>>(numberOfInstances);
    for (let i = 0; i < numberOfInstances; i++) {
        calls.push(getWithAuth("HEALTH", {}));
    }

    Promise.all(calls).then(() => {
        dispatch(setStatus(globalDialogStatus.loaded));
    })
    .catch(() => {
        dispatch(setStatus(globalDialogStatus.loadFailed));
    });
};

export default globalDialogSlice.reducer